import cn from "classnames";
import BookForm from "components/shared/book/form";
import { Transition } from "components/shared/column";
import Loader from "components/shared/loader";
import { utcTimeInOffset } from "helpers/date";
import { viewContainer } from "helpers/redux";
import React from "react";
import { filterTrackerLogs } from "sources/admin";
import { config, initialState } from "./config";

class FilterCoordinates extends BookForm {
    applyReq = (serialized) => {
        const { organizationTimezone } = this.props;
        serialized.from = utcTimeInOffset(serialized.from, organizationTimezone.utcOffset);
        serialized.to = utcTimeInOffset(serialized.to, organizationTimezone.utcOffset);
        return filterTrackerLogs({ ...serialized }).then(() => this.setState({ isLoading: false, isValid: false }));
    };

    renderBody = () => {
        const { organizationId, from, to } = this.props.config;
        return (
            <>
                {this.renderSelect(organizationId)}
                {this.renderDateField(from)}
                {this.renderDateField(to)}
            </>
        );
    };

    renderFooter = () => {
        return (
            <div className="book-form__actions">
                <input type="submit" className="btn btn-brand btn-sm" value="Отфильтровать" />
            </div>
        );
    };

    render() {
        const { isValid, isLoading } = this.state;
        const cname = cn("book-form__body", { "book-form__body--invalid": !isValid });
        return (
            <div className="page-content">
                <Transition dir="full">
                    {isLoading ? (
                        <div>
                            <Loader prefix="absolute-center" />
                        </div>
                    ) : (
                        <div>
                            {this.renderHead()}
                            <form className={cname} onSubmit={this.onSubmit}>
                                <div className="overflow-auto h-100">
                                    <div className="content-wrapper">{this.renderBody()}</div>
                                </div>
                                {this.renderFooter()}
                            </form>
                        </div>
                    )}
                </Transition>
            </div>
        );
    }
}

const ConfiguredForm = (props) => (
    <FilterCoordinates {...props} config={config} initialState={initialState} title="Фильтрация координат" />
);

export default viewContainer(ConfiguredForm, "admin-filter-coordinates");
